<template>
	<main class="get">

		<header class="getEvent">
			<div class="gradientOverlay"></div>
			<nav>
				<ul>
					<li><router-link to="/get-event/">Sailing</router-link></li>
					<li><router-link to="/get-event-navigation-sports/">Navigation sports</router-link></li>
					<li><router-link to="/get-event-route-sports/">Route sports</router-link></li>
				</ul>
			</nav>
			<div class="promo">
				<h1>TracTrac <strong>Event</strong></h1>
				<p>Make your event come alive with live tracking the excitement of fans, media and sponsors.</p>
				<a href="#getquote"><button class="normal">Get quote</button></a>
			</div>
		</header>

		<Benefits
			:image1="'https://s3.eu-central-1.amazonaws.com/tractrac/web/getevent-navigation-1.jpg'"
			:image2="'https://s3.eu-central-1.amazonaws.com/tractrac/web/getevent-navigation-2.jpg'"
			:image3="'https://s3.eu-central-1.amazonaws.com/tractrac/web/getevent-navigation-3.jpg'"
			:image4="'https://s3.eu-central-1.amazonaws.com/tractrac/web/getevent-navigation-4.jpg'"
			:image5="'https://s3.eu-central-1.amazonaws.com/tractrac/web/getevent-navigation-5.jpg'"
			:image6="'https://s3.eu-central-1.amazonaws.com/tractrac/web/getevent-navigation-6.jpg'"
			:competitors="'competitors'"
		/>

		<Steps pdf="_Other" />

		<Testimonials :list="testimonials" />

		<FAQ :show="faqShow" :showFaq="showFaq" />

		<GetQuoteForm :formUrl="'https://docs.google.com/forms/d/e/1FAIpQLScGnDNEBw8CXGcTRZH2fTBg0YIsI4axyRQfp_f01vtm2HGOjw/viewform?embedded=true'" :height="'2102px'" />

	</main>
</template>

<script>
// @ is an alias to /src
import Benefits from '@/components/Benefits.vue'
import Steps from '@/components/Steps.vue'
import Testimonials from '@/components/Testimonials.vue'
import TestimonialsList from '@/helpers/testimonials'
import FAQ from '@/components/FAQ.vue'
import GetQuoteForm from '@/components/GetQuoteForm.vue'

export default {
	name: 'home',
	components: {
		Benefits,
		Steps,
		Testimonials,
		FAQ,
		GetQuoteForm
	},
	data () {
		return {
			publicPath: process.env.BASE_URL,
			faqShow: '',
			testimonials: TestimonialsList.getFor('EventNavigation')
		}
	},
	methods: {
		showFaq (currentFaq) {
			this.faqShow = currentFaq
		}
	}
}

</script>

<style scoped lang="scss">

$link: #333;
$hover: #e74c3c;
$blueDark: rgba(0, 90, 132, 1);
$blueLight: rgba(0, 159, 194, 1);
$green: #63b323;
$grey: #9D9D9D;

.get header {
	position: relative;
	padding: 82px 0 48px 0;
	box-sizing: border-box;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-image: url(https://s3.eu-central-1.amazonaws.com/tractrac/web/event-orienteering.jpg);
	background-size: cover;
	background-position: center;
}

.get nav {
	position: relative;
	margin: 0;
	display: inline-flex;
}

.get nav ul {
	margin: 32px 0;
	padding: 0;
	list-style: none;
	display: flex;
	font-family: 'Raleway', sans-serif;
}

.get nav ul li {
	margin: 0 16px;
}

.get nav ul li a {
	color: white;
	text-decoration: none;
	text-transform: uppercase;
}

.get nav ul li a:hover,
.get nav ul li a.router-link-active {
	text-decoration: underline;
}

.get .promo {
	text-align: center;
	position: relative;
	color: white;
	padding: 0 32px;
}

.get .promo h1 {
	margin: 0 0 18px 0;
	font-weight: 300;
}

.get .promo h1 strong {
	margin: 0 0 18px 0;
	font-weight: 700;
}

@media only screen and (max-width: 480px) {

	.get header {
		padding: 82px 0 24px 0;
	}

	.get nav ul {
		margin: 24px 0;
		font-size: 12px;
		text-align: center;
	}

	.get nav ul li {
		margin: 0 8px;
	}
}

</style>
